import { useContext } from "react";
import { ColorProvider } from "~components/common/Layout";

export const CrueltyFree = () => {
  const { color, productBackground } = useContext(ColorProvider);
  return (
    <svg
      width="61"
      height="60"
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.33398" y="0.5" width="59" height="59" rx="29.5" fill="white" />
      <rect
        x="1.33398"
        y="0.5"
        width="59"
        height="59"
        rx="29.5"
        stroke="#E2DFDF"
      />
      <circle
        cx="30.834"
        cy="43.9802"
        r="5.77148"
        fill={productBackground || color}
      />
      <path
        d="M28.1156 27.2943C28.0281 26.0622 27.7292 24.6388 27.2971 23.4517C26.3566 20.8676 25.1421 20.3824 24.0115 20.7939C22.881 21.2054 22.2624 22.3577 23.203 24.9419C23.7406 26.4188 24.671 28.0434 25.5807 29.0879"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M33.5537 27.294C33.6412 26.0619 33.9402 24.6385 34.3722 23.4514C35.3128 20.8672 36.5273 20.382 37.6578 20.7936C38.7884 21.205 39.4069 22.3574 38.4664 24.9415C37.9287 26.4186 36.9981 28.0434 36.0883 29.0879"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M37.3903 33.241C37.1948 32.9794 37.1045 32.6523 37.1359 32.3273C37.1475 32.2066 37.1539 32.0847 37.1539 31.9614C37.1539 29.1057 34.3244 26.7907 30.8341 26.7907C27.3438 26.7907 24.5133 29.1057 24.5133 31.9614C24.5133 32.0847 24.5199 32.2067 24.5317 32.3274C24.5637 32.6524 24.4734 32.9794 24.2779 33.241C23.7059 34.0063 23.3652 34.9541 23.3652 35.9832C23.3652 38.5215 25.423 40.5793 27.9615 40.5793C28.7617 40.5793 29.5132 40.3738 30.168 40.0136C30.5788 39.7877 31.0894 39.7877 31.5002 40.0136C32.155 40.3738 32.9066 40.5793 33.7068 40.5793C36.2452 40.5793 38.303 38.5215 38.303 35.9832C38.303 34.9541 37.9624 34.0063 37.3903 33.241Z"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.834 30C15.834 38.2843 22.5497 45 30.834 45C39.1183 45 45.834 38.2843 45.834 30C45.834 21.7157 39.1183 15 30.834 15C22.5497 15 15.834 21.7157 15.834 30Z"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M30.834 39.5703V36.8473"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29.3311 36.2243C30.1609 37.0541 31.504 37.0541 32.3339 36.2243"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.1855 40.6479L41.4827 19.3509"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
